import { Button } from "@components/Button";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { useModal } from "@hooks";
import { Translations, i18n } from "@i18n";
import { useStyles } from "./styles";

export const GenericErrorContent = () => {
  const styles = useStyles();
  const { dismiss } = useModal();

  return (
    <div style={styles.container}>
      <Body style={styles.primary}>{i18n.t(Translations.ErrorComponentTitle)}</Body>
      <Spacing size={SpacingSizes.S} />
      <Body style={styles.secondary}>{i18n.t(Translations.ErrorComponentSubtitle)}</Body>
      <Spacing size={SpacingSizes.L} />

      <Button title={i18n.t(Translations.ErrorComponentPrimaryCTA)} onClick={dismiss} />
    </div>
  );
};
